import { Box, Grid, Typography } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../css/searchbar.css";
import helpfaq from "../img/helpfaq.png";
import webinar2 from "../img/webinar2.png";
import qrmessenger from "../img/qrmessenger.png";
import whatsappqr from "../img/whatsappqr.png";
import papertestqs from "../img/papertestqs.webp";
import papertestqss from "../img/papertestqss.png";
import onlineqs from "../img/onlineqs.png";
import { studentArticles, teacherArticles } from "./Help";
import {
  landingPageEvent,
  paperTestYoutube,
  quickstartYoutube,
} from "../utils/PixelEvents";

const useStyles = makeStyles((theme) => ({
  root: {},
  font: {
    color: "white",
  },
  helpbar: {
    height: "200px",
    backgroundColor: "#938bf2",
  },
  search: {
    marginTop: "15px",
    backgroundColor: "white",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 0 0 1.5px #9287FF",
    marginLeft: 0,
    width: "100%",
  },
  searchIcon: {
    height: "100%",
    paddingRight: "20px",
    display: "inline",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "35ch",
    height: "30px",
    [theme.breakpoints.up("md")]: {
      width: "50ch",
      "&:hover": {
        width: "55ch",
      },
      "&:focus": {
        width: "55ch",
      },
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  paperCat: {
    width: "100%",
    padding: "10px 0px",
    minHeight: "100px",
    textAlign: "center",
    border: "1px solid #D3D3D3",
    "&:hover": {
      backgroundColor: "#f7f7f7",
      border: "1px solid rgb(147, 139, 242,0.5)",
    },
  },
  paperCatSplit: {
    width: "100%",
    padding: "10px 0px",
    minHeight: "100px",
    textAlign: "center",
    border: "1px solid #D3D3D3",
  },
  helpCatNum: {
    color: "#4381b5",
    fontSize: "13px",
    marginTop: "10px",
  },
  helpCatHeading: {
    fontSize: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px !important",
    },
  },
  teacherHelpSection: {
    margin: "50px 10%",
    [theme.breakpoints.down("xs")]: {
      margin: "50px 3%",
    },
  },

  askForHelpWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  smallIcons: {
    width: "60%",
    maxWidth: "45px !important",
    marginTop: "10px",
  },
  normalLink: {
    textDecoration: "none",
    color: "#8277FF",
  },
  gridHalfContainer: {
    height: "100%",
    padding: "10px 5px",
    "&:hover": {
      backgroundColor: "#f7f7f7",
      boxShadow: " 0 0 0 1px rgb(147, 139, 242,0.5)",
    },
  },
  whatsappqr: {
    margin: "0px",
    maxWidth: "60%",
    width: "150px",
  },
  askrowwrapper: {
    display: "flex",
    width: "max-content",
    flexDirection: "column",
    margin: "40px 0px",
    [theme.breakpoints.down("xs")]: {
      alignItems: "center",
    },
  },
  vidbox: {
    width: "100%",
    height: "100%",
    border: "2px solid #938BF2",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    transition: "all .2s ease-in-out",

    "&:hover": {
      transform: "scale(1.1)",
      cursor: "pointer",
      boxShadow: "0px 0px 15px rgb(0,0,0,0.3)",
    },
  },
}));

function HelpCategory(props) {
  const classes = useStyles();
  const articles = () => {
    const filt = teacherArticles.filter(function (obj) {
      return obj.Category === props.category;
    });
    if (filt.length === 0) {
      const filt2 = studentArticles.filter(function (obj) {
        return obj.Category === props.category;
      });
      return filt2.length;
    }
    return filt.length;
  };
  return (
    <>
      <Grid item xs={6} sm={4} container justifyContent="center">
        <div
          style={{
            width: "100%",
            maxWidth: "400px",
          }}
        >
          <Link
            style={{
              textDecoration: "none",
              color: "black",
            }}
            to={`/${props.helpoptions}/${props.link}`}
          >
            <Grid
              container
              className={classes.paperCat}
              justifyContent="center"
              direction="column"
              alignItems="center"
            >
              <Grid item className={classes.helpCatHeading}>
                {props.category}
              </Grid>
              <Grid item className={classes.helpCatNum}>
                <span>{articles()}</span> Articles
              </Grid>
            </Grid>
          </Link>
        </div>
      </Grid>
    </>
  );
}
// function HelpCategoryExtra(props) {
//   const classes = useStyles();

//   return (
//     <>
//       <Helmet>
//         <title>
//           Help Topics, Tips and Resources to Learn More About SwiftGrade
//         </title>
//         <meta
//           name="description"
//           content="SwiftGrade can grade both paper and online assessments making it great for virtual, in-person, or hybrid learning. Helping teachers reduce grading load for handwritten assessments by 80-90%."
//         />
//       </Helmet>
//       <Grid item xs={6} sm={4} container justifyContent="center">
//         <Grid
//           container
//           style={{ paddingTop: "0px", paddingBottom: "0px", maxWidth: "400px" }}
//           className={classes.paperCatSplit}
//         >
//           <Grid container>
//             <Link
//               style={{
//                 textDecoration: "none",
//                 color: "black",
//                 width: "50%",
//               }}
//               to={`/questions`}
//             >
//               <Grid
//                 container
//                 direction="column"
//                 alignItems="center"
//                 justifyContent="center"
//                 className={classes.gridHalfContainer}
//               >
//                 <div className={classes.helpCatHeading}>FAQ Page</div>
//                 <img
//                   style={{ maxWidth: "100px" }}
//                   className={classes.smallIcons}
//                   src={helpfaq}
//                   alt="Numeric"
//                 />
//               </Grid>
//             </Link>
//             <Link
//               style={{
//                 textDecoration: "none",
//                 color: "black",
//                 width: "50%",
//               }}
//               to={`/webinar`}
//             >
//               <Grid
//                 container
//                 direction="column"
//                 alignItems="center"
//                 justifyContent="center"
//                 className={classes.gridHalfContainer}
//               >
//                 <div className={classes.helpCatHeading}>Webinar</div>
//                 <img
//                   style={{ maxWidth: "100px" }}
//                   className={classes.smallIcons}
//                   src={webinar2}
//                   alt="webinar"
//                 />
//               </Grid>
//             </Link>
//           </Grid>
//         </Grid>
//       </Grid>
//     </>
//   );
// }

function Helphome() {
  const allOptions = [...teacherArticles, ...studentArticles];
  const classes = useStyles();

  useEffect(() => {
    landingPageEvent();
  }, []);

  return (
    <div className={classes.root}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        className={classes.helpbar}
      >
        <Typography className={classes.font} variant="h5">
          SwiftGrade Help Center
        </Typography>

        <Autocomplete
          id="controllable-states-demo"
          noOptionsText="No suggestions- Try key ideas and browse topics"
          options={allOptions}
          ListboxProps={{
            style: {
              position: "absolute",
              backgroundColor: "#fafafa",
              borderRadius: "5px",
            },
          }}
          openOnFocus={true}
          getOptionLabel={(option) => option.Topic}
          renderOption={(option) => (
            <Link
              style={{
                width: "100%",
                color: "black",
                height: "100%",
                textDecoration: "none",
              }}
              to={`/help-topics/${option.Sublink}/${option.Link}`}
            >
              <div
                style={{
                  height: "100%",
                  margin: "10px 20px 10px 20px",
                }}
              >
                {option.Category} - {option.Topic}
              </div>
            </Link>
          )}
          renderInput={(params) => (
            <div ref={params.InputProps.ref} className={classes.search}>
              <InputBase
                {...params.inputProps}
                placeholder="Search"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ "aria-label": "search" }}
              />
              <div className={classes.searchIcon}>
                <SearchIcon
                  style={{
                    color: "#646f79",
                    fontSize: "35px",
                    verticalAlign: "middle",
                  }}
                />
              </div>
            </div>
          )}
        />
      </Grid>
      <Grid container justifyContent="center">
        <Grid item style={{ margin: "40px 5% 0px 5%" }}>
          <a
            className={classes.vidbox}
            href="https://www.youtube.com/watch?v=j7RtINY1UIQ&list=PL5MJvbOcQoX84O14-9JCn9zPDgXbEXk2d&index=2"
            target="_blank"
            onClick={() => {
              paperTestYoutube();
            }}
          >
            <img
              src={papertestqss}
              alt="Quick start for paper testing"
              style={{ width: "92vw", maxWidth: "300px" }}
            />
          </a>
        </Grid>
        <Grid item style={{ margin: "40px 6% 0px 6%" }}>
          <a
            className={classes.vidbox}
            href="https://www.youtube.com/watch?v=9_vCbP5jYLI&list=PL5MJvbOcQoX84O14-9JCn9zPDgXbEXk2d&index=12"
            target="_blank"
            onClick={quickstartYoutube()}
          >
            <img
              src={onlineqs}
              alt="Quick start for online testing"
              style={{ width: "92vw", maxWidth: "300px" }}
            />
          </a>
        </Grid>
      </Grid>
      <div className={classes.teacherHelpSection}>
        <Typography variant="h5">TEACHER HELP</Typography>
        <Grid
          sx={{ flexGrow: 1 }}
          container
          spacing={2}
          style={{ rowGap: "10px" }}
        >
          <HelpCategory
            link="key-ideas"
            category="Key ideas"
            helpoptions={"help-options"}
          />
          <HelpCategory
            helpoptions={"help-options"}
            link="different-answer-types"
            category="Our different answer types"
          />
          <HelpCategory
            link="create-answer-key"
            category="Creating an answer key"
            helpoptions={"help-options"}
          />
          <HelpCategory
            link="answer-sheets"
            category="Answer sheets"
            helpoptions={"help-options"}
          />
          <HelpCategory
            helpoptions={"help-options"}
            link="scanning-paper-answer-sheets"
            category="Scanning paper answer sheets"
          />
          <HelpCategory
            helpoptions={"help-options"}
            link="view-results"
            category="View and send results"
          />
          <HelpCategory
            helpoptions={"help-options"}
            link="handwriting-rec"
            category="Handwriting recognition accuracy"
          />
        </Grid>
      </div>
      <div className={classes.teacherHelpSection}>
        <Typography variant="h5">STUDENT HELP</Typography>
        <Grid
          sx={{ flexGrow: 1 }}
          container
          spacing={2}
          style={{ rowGap: "10px" }}
        >
          <HelpCategory
            helpoptions={"student-help"}
            category="Getting started"
            link="getting-started"
          />
          <HelpCategory
            helpoptions={"student-help"}
            category="Taking assessments"
            link="taking-assessments"
          />
        </Grid>
      </div>
      <div className={classes.teacherHelpSection}>
        <div className={classes.askForHelpWrapper}>
          <Typography variant="h5">ASK FOR HELP</Typography>
          <div>
            To request a feature, report an issue, or ask a question, email us
            at{" "}
            <a
              className={classes.normalLink}
              href="mailto:support@goswiftgrade.com"
            >
              support@goswiftgrade.com
            </a>{" "}
            or message us by scanning one of the codes below:
          </div>
          <Grid container>
            <Grid item xs={12} sm={6} className={classes.askrowwrapper}>
              <Typography variant="h6" style={{ margin: "5px" }}>
                Contact us on Whatsapp:
              </Typography>
              <img
                className={classes.whatsappqr}
                src={whatsappqr}
                alt="Whatsapp QR"
              />

              <Typography style={{ margin: "5px" }}>+1236668799</Typography>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.askrowwrapper}>
              <Typography variant="h6" style={{ margin: "5px" }}>
                Contact us on Messenger:
              </Typography>
              <img
                className={classes.whatsappqr}
                src={qrmessenger}
                alt="Facebook QR"
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Helphome;
